<template>
  <nuttrema-layout-form-standard :edit="edit" theme="west-top" :saveError="PersonalProfile.saveError">
    <template slot="center">
      <el-form :model="formData" :rules="rules" :ref="formRef" label-position="top">
        <section>
          <h4 class="section-title"></h4>
          <div class="section-items">
            <el-form-item :label="$t('label.interests')" prop="PersonData.professional_biography_interests">
              <el-col class="el-col--min-21em" :span="24">
                <el-input v-model="formData.PersonData.professional_biography_interests.value" type="textarea" :autosize="{ minRows: 4, maxRows: 12}"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>
      </el-form>
    </template>
    <template slot="footer">
      <div class="footer-row">
        <el-button
           type="primary"
           size="small"
          :disabled="!isDataChanged"
          :loading="isSaving"
          @click="submitForm">
            {{ $t('label.save') }}
        </el-button>

        <el-button type="text" size="small" @click="cancelChanges(false)">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { assign, get, cloneDeep } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-personal-interests-cred',
  mixins: [FormStandardBehavior],
  props: {
    PersonalProfile: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        PersonData: {
          professional_biography_interests: {
            section: 'professional_biography',
            key: 'interests',
            value: null,
          },
        },
      },
      rules: {
        'PersonData.professional_biography_interests': [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.interests', true),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    setFormData() {
      const personData = get(this.PersonalProfile, 'data.PersonData.professional_biography_interests', {});
      assign(this.formData.PersonData.professional_biography_interests, personData);
      this.originalData = cloneDeep(this.formData);
    },
    getFormData() {
      return cloneDeep(this.formData);
    },
  },
  created() {
    this.stateData = this.PersonalProfile;
    this.formRef = 'form-professional-interests';
    this.setFormData();
  },
};
// school degree date_from
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/professional-biography/form-personal-interests-cred.vue